// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jGiR","field":"styles_field__18qRJ","fieldCol":"styles_fieldCol__1bpeZ","diffCol":"styles_diffCol__1epcx","diff":"styles_diff__32m03"};